// One plug-in fires a burst of devicechange events; waiting this long folds the burst into one.
export const DEVICE_CHANGE_DEBOUNCE_MS = 300;
